module.exports = __webpack_public_path__ + "img/03_full.a63ea37b.jpg";